/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterPushNotificationCategoryRequest
 */
export interface RegisterPushNotificationCategoryRequest {
    /**
     * 
     * @type {boolean}
     * @memberof RegisterPushNotificationCategoryRequest
     */
    defaultEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterPushNotificationCategoryRequest
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterPushNotificationCategoryRequest
     */
    key: string;
}

/**
 * Check if a given object implements the RegisterPushNotificationCategoryRequest interface.
 */
export function instanceOfRegisterPushNotificationCategoryRequest(value: object): value is RegisterPushNotificationCategoryRequest {
    if (!('defaultEnabled' in value) || value['defaultEnabled'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function RegisterPushNotificationCategoryRequestFromJSON(json: any): RegisterPushNotificationCategoryRequest {
    return RegisterPushNotificationCategoryRequestFromJSONTyped(json, false);
}

export function RegisterPushNotificationCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterPushNotificationCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultEnabled': json['defaultEnabled'],
        'displayName': json['displayName'],
        'key': json['key'],
    };
}

export function RegisterPushNotificationCategoryRequestToJSON(value?: RegisterPushNotificationCategoryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'defaultEnabled': value['defaultEnabled'],
        'displayName': value['displayName'],
        'key': value['key'],
    };
}

